import React, { useEffect, useState, useRef } from "react";
import FieldIcon from "../utils/Register/field_icon";
import SendBtn from "../utils/Register/send_btn";
import MenuField from "../utils/Register/menu_field";
import CircleAvatar from "../utils/Register/circular_profile_img";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { FaTimes } from "react-icons/fa";

const PlayerFormPopup = ({ onClose, selectedSubcategory, team }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [identification, setIdentification] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [birth_date, setDate] = useState("");
  const [review, setReview] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [error, setError] = useState("");
  const [avatarFile, setAvatarFile] = useState(null);
  const [userId, setUserId] = useState("");
  const token = useSelector((state) => state.user.token);

  const options = [
    { value: "Ameteur", label: "Ameteur" },
    { value: "Profesional", label: "Profesional" },
    { value: "Profesional retirado", label: "Profesional retirado" },
    { value: "Prefiero no decirlo", label: "Prefiero no decirlo" },
  ];

  const popupRef = useRef(null);

  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token);
      setUserId(decodedToken.id);
    }

    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [token, onClose]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !firstName ||
      !lastName ||
      !identification ||
      !phone ||
      !city ||
      !selectedOption ||
      !birth_date
    ) {
      setError(
        "Por favor, complete todos los campos, incluyendo el tipo de jugador."
      );
      return;
    }

    try {
      const playerResponse = await fetch(
        "https://server-postgre.vercel.app/api/players",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            first_name: firstName,
            last_name: lastName,
            identification,
            birth_date,
            phone,
            city,
            review,
            user_id: userId,
            player_type: selectedOption,
          }),
        }
      );

      const playerData = await playerResponse.json();
      if (!playerResponse.ok) throw new Error(playerData.message);
      const playerId = playerData.id;

      if (team?.id) {
        const assignResponse = await fetch(
          "https://server-postgre.vercel.app/api/players/assign",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              team_id: team.id,
              player_id: playerId,
              team_category_id: selectedSubcategory?.id || null,
            }),
          }
        );

        const assignData = await assignResponse.json();
        if (!assignResponse.ok) throw new Error(assignData.message);
      }

      window.location.href = "/";
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999] p-4">
      <div
        ref={popupRef}
        className="bg-white rounded-2xl shadow-xl w-11/12 max-w-2xl max-h-[90vh] flex flex-col overflow-hidden relative"
      >
        {/* Botón cerrar dentro del popup */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-600 hover:text-gray-900 z-10"
        >
          <FaTimes size={20} />
        </button>

        {/* Contenedor scrollable */}
        <div className="overflow-y-auto flex-1 p-6 pt-6">
          {/* Avatar dentro del scroll */}
          <div className="flex justify-center mb-6">
            <CircleAvatar
              size={100}
              onImageSelect={(e) => setAvatarFile(e.target.files[0])}
              imageUrl={avatarFile ? URL.createObjectURL(avatarFile) : null}
            />
          </div>

          <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
            Crear Jugador
          </h2>

          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-1 md:grid-cols-2 gap-4"
          >
            <FieldIcon
              id="first_name"
              name="first_name"
              type="text"
              placeholder="Nombre"
              value={firstName}
              required
              label="Nombre"
              onChange={(e) => setFirstName(e.target.value)}
            />
            <FieldIcon
              id="last_name"
              name="last_name"
              type="text"
              placeholder="Apellido"
              value={lastName}
              required
              label="Apellido"
              onChange={(e) => setLastName(e.target.value)}
            />
            <FieldIcon
              id="identification"
              name="identification"
              type="text"
              placeholder="Cédula"
              value={identification}
              required
              label="CI"
              onChange={(e) => setIdentification(e.target.value)}
            />
            <FieldIcon
              id="birth_date"
              name="birth_date"
              type="date"
              placeholder="Fecha de nacimiento"
              value={birth_date}
              required
              label="Fecha de nacimiento"
              onChange={(e) => setDate(e.target.value)}
            />
            <FieldIcon
              id="phone"
              name="phone"
              type="tel"
              placeholder="Teléfono"
              value={phone}
              required
              label="Teléfono"
              onChange={(e) => setPhone(e.target.value)}
            />
            <FieldIcon
              id="city"
              name="city"
              type="text"
              placeholder="Ciudad"
              value={city}
              required
              label="Ciudad"
              onChange={(e) => setCity(e.target.value)}
            />
            <div className="md:col-span-2">
              <MenuField
                label="Tipo de jugador"
                placeholder="Selecciona una opción"
                options={options}
                selectedOption={selectedOption}
                onOptionSelect={setSelectedOption}
              />
            </div>
            <div className="md:col-span-2">
              <FieldIcon
                id="review"
                name="review"
                type="text"
                placeholder="Sobre el jugador"
                value={review}
                label="Reseña"
                onChange={(e) => setReview(e.target.value)}
              />
            </div>

            {error && (
              <p className="text-red-500 md:col-span-2 text-center mt-2">
                {error}
              </p>
            )}

            <div className="md:col-span-2 mt-6 flex justify-center">
              <SendBtn
                label="Guardar"
                style={{
                  background: "linear-gradient(to right, #4f46e5, #e5960e)",
                  color: "white",
                }}
                type="submit"
                onClick={handleSubmit}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PlayerFormPopup;
